import React, { useMemo } from "react";
import "./ExploreCard.css";
import { Col, Card } from "react-bootstrap";
import { getImageUrl, isValidNumber } from "../../../utils/Functions/Filter";
import dummy from "../../../assets/images/no-img.jpg";
import { useNavigate } from "react-router-dom";
const ExploreCard = ({ item = {} }) => {
  const navigate = useNavigate();
  const {
    default_creator_commission,
    default_mark_down,
    brand_page_image_urls,
    brand_name,
    brand_domain,
  } = item;
  const percentage = isValidNumber(default_creator_commission)
    ? Number(default_creator_commission)
    : 50;
  const brandImage = getImageUrl(brand_page_image_urls, "thumbnail");
  const commission = useMemo(
    () => (isValidNumber(default_mark_down) ? (default_mark_down / 100) * percentage + "%" : "-"),
    [default_mark_down, percentage]
  );
  return (
    <Col
      lg={4}
      md={6}
      sm={12}
      className="explore_card_container"
      onClick={(e) => {
        navigate(`/brand/${brand_domain}`);
      }}
    >
      <Card id={item.id}>
        <div className="image_container">
          <img className={"bg_image"} src={brandImage ? brandImage : dummy} alt="brand-img" />
        </div>
        <div className="title_container">
          <h5 className="explore_card_title">{brand_name}</h5>
          {/* <a href={item?.website_url ? item?.website_url : ""}>{item.brand_name}</a> */}
          {/* <p className="explore_para">
                      {getMetaValue(item?.brand_content_meta, "thumbnail_description") || "-"}
                    </p> */}
          <div className="explore-card-commission">
            <p>Commission: {commission}</p>
          </div>
          <div className="btn-container">
            <button className="apply-button">Apply now</button>
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default ExploreCard;
